import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import {
  IconMail,
  IconPin,
  IconInstagram,
  IconHome,
  IconCalendar,
  IconShield,
} from "./Icons";

const initialState = { from_name: "", from_email: "", message: "" };

export const Contact = ({ data, onOpenPrivacy }) => {
  const [form, setForm] = useState(initialState);
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!consent) {
      setStatus({ type: "error", text: "Please accept the privacy notice to send your message." });
      return;
    }
    setSending(true);
    setStatus(null);

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          setStatus({ type: "ok", text: "Thank you — your message has been sent." });
          setForm(initialState);
          setConsent(false);
        },
        () => {
          setStatus({
            type: "error",
            text: "Something went wrong. Please email us directly at casacarmelapositano@gmail.com.",
          });
        }
      )
      .finally(() => setSending(false));
  };

  return (
    <section className="section section--sea" id="contact">
      <div className="container">
        <div className="contact">
          <div>
            <div className="section-head section-head--left">
              <span className="eyebrow">Get in touch</span>
              <h2>Plan your stay</h2>
              <hr className="rule" />
              <p>
                Questions about the house, transfers or the area? We're always happy to help.
              </p>
            </div>

            <form onSubmit={handleSubmit} noValidate>
              <div className="field">
                <label htmlFor="from_name">Name</label>
                <input
                  id="from_name"
                  type="text"
                  name="from_name"
                  placeholder="Your name"
                  required
                  autoComplete="name"
                  onChange={handleChange}
                  value={form.from_name}
                />
              </div>

              <div className="field">
                <label htmlFor="from_email">Email</label>
                <input
                  id="from_email"
                  type="email"
                  name="from_email"
                  placeholder="you@example.com"
                  required
                  autoComplete="email"
                  onChange={handleChange}
                  value={form.from_email}
                />
              </div>

              <div className="field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  placeholder="Tell us about your trip…"
                  required
                  onChange={handleChange}
                  value={form.message}
                />
              </div>

              <label className="consent-check">
                <input
                  type="checkbox"
                  checked={consent}
                  onChange={(e) => setConsent(e.target.checked)}
                  required
                />
                <span>
                  I have read the{" "}
                  <button type="button" className="link-btn" onClick={onOpenPrivacy}>
                    privacy notice
                  </button>{" "}
                  and agree that my name, email and message will be used only to answer this
                  enquiry.
                </span>
              </label>

              <button type="submit" className="btn btn--accent" disabled={sending}>
                {sending ? "Sending…" : "Send message"}
              </button>

              {status && (
                <p
                  className={`form-status ${status.type === "error" ? "form-status--error" : ""}`}
                  role="status"
                >
                  {status.text}
                </p>
              )}
            </form>
          </div>

          <div className="contact__info">
            <div className="contact__item">
              <IconPin />
              <div>
                <span>Address</span>
                <a
                  href={`https://www.google.com/maps?q=${encodeURIComponent(
                    data?.address || ""
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {data?.address}
                </a>
              </div>
            </div>

            <div className="contact__item">
              <IconMail />
              <div>
                <span>Email</span>
                <a href={`mailto:${data?.email}`}>{data?.email}</a>
              </div>
            </div>

            <div className="contact__item">
              <IconShield />
              <div>
                <span>Licence numbers</span>
                <p>15065100LOB0606 · IT065100C23BE6SK6P</p>
              </div>
            </div>

            <div className="contact__social">
              <a
                className="social-btn"
                href={data?.instagram || "https://www.instagram.com/casacarmelapositano/"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconInstagram width={16} height={16} />
                Instagram
              </a>
              <a
                className="social-btn"
                href={data?.airbnb || "https://www.airbnb.com/rooms/826055515812450770"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconHome width={16} height={16} />
                Airbnb
              </a>
              <a
                className="social-btn"
                href={data?.booking || "https://www.booking.com/hotel/it/casa-carmela-positano.html"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconCalendar width={16} height={16} />
                Booking.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
